import axios from 'axios'

export default {
  getPoint: (params) => {
    return new Promise((resolve) => {
      axios.get('station', { params: params })
        .then(payload => {
          resolve(payload.data.ResultSet.Point)
        })
    })
  }
}
